import { Integration_Names_Enum } from '@main/graphql/types.generated';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';
import { AtlassianAuthPat } from '../../lib/atlassian';

export type ConfluenceConnectorConfig = typeof ConfluenceConnector._.Config;

export const ConfluenceConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Confluence,
  logoPath: 'images/confluence-logo.svg',
  categories: [IntegrationConnectorCategory.Productivity],
  auths: IntegrationAuth.group([AtlassianAuthPat]),
});
